import { createSlice } from "@reduxjs/toolkit";
import {
    fetchQuestionTableColumnNames,
    fetchAllQuestions,
    createQuestions,
    updateQuestions,
    deleteQuestions,
    activateDeactivateQuestions,
    questionOptions,
    fetchAiQuestions,
    fetchAllScore,
    fetchSubTopic
} from "./thunk";
import { toast } from "react-toastify";

const questionsSlice = createSlice({
  name: "questions",
  initialState: {
    questions: [],
    questionsScore: [],
    questionsSubTopic: [],
    aiQuestions: [],
    tableColumnNames: [],
    loading: false,
    headerLoad: false,
    loadingAi: false,
    error: null,
  },
  reducers: { 
    clearAiQuestionsState(state) {      
      state.aiQuestions = [];
      state.loadingAi = false;
      state.error = null; 
    },
  },
  extraReducers: (builder) => {
    builder

    // Fetch Question Table Column Names
    .addCase(fetchQuestionTableColumnNames.pending, (state) => {
      state.headerLoad = true;
      state.error = null;
    })
    .addCase(fetchQuestionTableColumnNames.fulfilled, (state, action) => {
      state.headerLoad = false;
      state.tableColumnNames = action.payload;
    })
    .addCase(fetchQuestionTableColumnNames.rejected, (state, action) => {
      state.headerLoad = false;
      state.error = action.payload;
    })

    // Get All Questions
    .addCase(fetchAllQuestions.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchAllQuestions.fulfilled, (state, action) => {
      state.loading = false;
      state.questions = action.payload;
    })
    .addCase(fetchAllQuestions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    // Add Question
    .addCase(createQuestions.pending, (state) => {
      state.error = null;
    })
    .addCase(createQuestions.fulfilled, (state, action) => {
      state.questions = [...action.payload.data, ...state.questions];
      toast.success(action.payload.message);
    })
    .addCase(createQuestions.rejected, (state, action) => {
      state.error = action.payload;
    })

    // Update Question
    .addCase(updateQuestions.pending, (state) => {
      state.error = null;
    })
    .addCase(updateQuestions.fulfilled, (state, action) => {
      const index = state.questions.findIndex(
        (item) => item.ID === action.payload[0].ID
      );

      if (index >= 0) {
        state.questions[index] = action.payload[0];
      }
    })
    .addCase(updateQuestions.rejected, (state, action) => {
      state.error = action.payload;
    })

    // Delete Question
    .addCase(deleteQuestions.pending, (state) => {
      state.error = null;
    })
    .addCase(deleteQuestions.fulfilled, (state, action) => {
      const deletedIds = action.payload.map((item) => item.ID);

      // Filter out the deleted items
      state.questions = state.questions.filter((item) => !deletedIds.includes(item.ID));

    })
    .addCase(deleteQuestions.rejected, (state, action) => {
      state.error = action.payload;
    })

    // Active Deactive Question
    .addCase(activateDeactivateQuestions.pending, (state) => {
      state.error = null;
    })
    .addCase(activateDeactivateQuestions.fulfilled, (state, action) => {
      if (action.payload) {
        const updatedQuestion = action.payload[0] || {};

        state.questions = state.questions.map((item) => item.ID === updatedQuestion.ID ? {...item, IsActive: updatedQuestion.IsActive} : item)
      }
    })
    .addCase(activateDeactivateQuestions.rejected, (state, action) => {
      state.error = action.payload;
    })

    // Add Question
    .addCase(questionOptions.pending, (state) => {
        state.error = null;
    })
    .addCase(questionOptions.fulfilled, (state, action) => {
        state.questions = state.questions.map((item) => item.ID === action.payload.data.QuestionID ? {...item,  NoOfOptions:action.payload.data.Options.length, Options: action.payload.data.Options}: item);
    })
    .addCase(questionOptions.rejected, (state, action) => {
        state.error = action.payload;
    })

    // Get AI Questions
    .addCase(fetchAiQuestions.pending, (state) => {
      state.loadingAi = true;
      state.error = null;
    })
    .addCase(fetchAiQuestions.fulfilled, (state, action) => {
      state.loadingAi = false;
      state.aiQuestions = action.payload;
    })
    .addCase(fetchAiQuestions.rejected, (state, action) => {
      state.loadingAi = false;
      state.error = action.payload;
    })

    // Get All Score
    .addCase(fetchAllScore.pending, (state) => {
      state.error = null;
    })
    .addCase(fetchAllScore.fulfilled, (state, action) => {
      state.questionsScore = action.payload;
    })
    .addCase(fetchAllScore.rejected, (state, action) => {
      state.error = action.payload;
    })
  
  },
});

export const { clearAiQuestionsState } = questionsSlice.actions; 
export default questionsSlice.reducer;
